import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "link", "hint"];
  static values = { baseUrl: String };

  connect() {
    if (this.hasSelectTarget) this.sync();
  }

  sync() {
    const id = this.selectTarget.value;
    if (id) {
      this.linkTarget.href = `${this.baseUrlValue}&guild_id=${id}&disable_guild_select=true`;
      this.linkTarget.classList.remove("hidden");
      this.hintTarget.classList.add("hidden");
    } else {
      this.linkTarget.classList.add("hidden");
      this.hintTarget.classList.remove("hidden");
    }
  }
}
